
export const CONTACT_US = {
    GET_CONTACT : 'contact-us/list',
    GET_PARTNER_CONTACT : 'contact-us/partner-contact-list',
}
export const AUTHENTICATION = {
    LOGIN_USER: 'Auth/login',
    FORGOT_PASSWORD: 'User/Forgot',
    RESET_PASSWORD: 'User/Reset',
    PASSWORD_REQUEST: 'CandidateAPIV2/PasswordRequest',
    SESSION_BREAK_START: 'auth/Session/break/start',
    SESSION_BREAK_END: 'auth/Session/break/end',
}

export const USER_INFO = {
    GET_PERMISSIONS: 'user-info/permissions',
    PROFILE: 'user-info/profile',
}

export const GENERAL_TESTIMONIAL = {
    GET_GENERAL_TESTIMONIALS : 'testimonials/testimonials-list',
    ADD_GENERAL_TESTIMONIALS : 'testimonials/add-testimonial',
    EDIT_GENERAL_TESTIMONIALS : 'testimonials/update-testimonial'
}
export const TEAM_MEMBERS = {
    GET_TEAMS : 'team-members/list',
    ADD_TEAM : 'team-members/add-team-member',
    EDIT_TEAM : 'team-members/update-team-member',
    UPDATE_TEAM_DETAILS : 'team-members/update-team-member-section'
}

export const PARTNERS = {
    GET_PARTNER : 'partners/list',
    ADD_PARTNER : 'partners/add-partner',
    EDIT_PARTNER : 'partners/update-partner',
    FETCH_PARTNER: 'partner/fetch-partner',
    UPDATE_PARTNER_DETAILS: 'partners/update-page-details'
}

export const ADVANTAGE = {
    GET_ADVANTAGE_LIST : 'pages/advantages-list',
    ADD_ADVANTAGE: 'pages/add-advantage',
    EDIT_ADVANTAGE : 'pages/update-advantage',
    UPDATE_ADVANTAGE_FETCH_DETAILS: 'pages/update-advantage-page-details'
}

export const RECRUITMENT = {
    EDIT_RECRUITMENT : 'pages/update-whyus-page-details',
    GET_RECRUITMWNT : 'pages/get-whyus-page-details',
}

export const CONTACT = {
    GET_CONTACT : 'pages/get-contactus-page-details',
    EDIT_CONTACT : 'pages/update-contactus-page-details',
    UPDATE_CONTACT_DETAILS: 'pages/update-contactus-section-details',
    GET_CONTACT_DETAILS: 'pages/get-contactus-section-details'
}

export const ABOUT_US = {
    GET_ABOUT_US_INFO_LIST : 'pages/get-about-us-about-section',
    ADD_ABOUT_US_INFO : 'pages/add-aboutus-step',
    EDIT_ABOUT_US_INFO : 'pages/update-aboutus-step',
    FETCH_ABOUT_US_MAIN: 'aboutus/aboutus-fetch',
    UPDATE_ABOUT_US_MAIN : 'pages/update-about-us-section',
    ADD_ABOUT_US_MISSION_VISION : 'pages/add-aboutus-vision-mission',
    EDIT_ABOUT_US_MISSION_VISION : 'pages/update-aboutus-vision-mission',
    GET_ABOUT_US_MAIN_PRIORITY_LIST : 'pages/get-aboutus-service-section',
    ADD_ABOUT_US_PRIORITY : 'pages/add-aboutus-service',
    EDIT_ABOUT_US_PRIORITY : 'pages/update-aboutus-service',
    UPDATE_ABOUT_US_MAIN_TITLE : 'pages/update-aboutus-main-title',
    UPDATE_ABOUT_US_PRIORITY_MAIN_TITLE : 'pages/update-aboutus-service-section',
    FETCH_VALUABLE_TEAM: 'pages/get-aboutus-team-section-details',
    UPDATE_VALUABLE_TEAM : 'pages/update-aboutus-team-section-details',
    GET_ABOUT_US_RECRUITMENT_LIST : 'pages/get-aboutus-recruitment-section-details',
    UPDATE_ABOUT_US_RECRUITMENT_TEAM : 'pages/update-aboutus-recruitment-list',
    GET_ABOUT_US_MAIN_PROCESS_LIST : 'pages/get-aboutus-process-section',
    UPDATE_ABOUT_US_PROCESS_MAIN_TITLE : 'pages/update-aboutus-process-section',
    ADD_ABOUT_US_PROCESS : 'pages/add-aboutus-process',
    EDIT_ABOUT_US_PROCESS : 'pages/update-aboutus-process',
    UPDATE_ABOUT_US_RECRUITMENT_TITLE : 'pages/update-aboutus-recruitment-section-details',
    ADD_ABOUT_US_RECRUITMENT : 'pages/add-aboutus-recruitment',
    EDIT_ABOUT_US_RECRUITMENT : 'pages/update-aboutus-recruitment',
    FETCH_ABOUT_US_PARTNER: 'pages/get-aboutus-partner-section-details',
    UPDATE_ABOUT_US_PARTNER : 'pages/update-aboutus-partner-section-details',

    // for recruitment process

    UPDATE_RECRUITMENT_PROCESS: 'pages/update-recruiting-process-section-details',
    GET_RECRUITMENT_PROCESS: 'pages/get-recruiting-process-section-details',
    ADD_RECRUITMENT_PROCESS : 'pages/add-recruiting-step',
    EDIT_RECRUITMENT_PROCESS : 'pages/update-recruiting-step/',




}

export const BLOG = {
     // for blog section
     GET_BLOG_DETAILS : 'pages/get-blogs-section-details',
     UPDATE_BLOG_DETAILS: 'pages/update-blogs-section-details',
     GET_BLOG_LIST : 'pages/get-blogs',
     ADD_BLOG : 'pages/add-blog',
     EDIT_BLOG : 'pages/update-blog',
}

export const CATEGORY = {
    GET_CATEGORY_LIST : 'master/JobCategory',
    ADD_CATEGORY : 'pages/add-blog-category',
    EDIT_CATEGORY : 'pages/update-blog-category',
    GET_JOB_CATEGORY_SCHEMA: 'master/JobCategory/metadata',
    SUBMIT_FILTER_DATA: 'master/JobCategory/filter',
    REGISTER_FIELD: 'master/RegisterFieldGroup/by-job-category',
    SUBMIT_REGISTER_FIELD: 'master/RegisterFieldGroup'
}

/** FADV API Package master — metadata, filter, CRUD */
export const FADV_API_PACKAGE = {
    LIST: 'master/FadvApiPackage',
    METADATA: 'master/FadvApiPackage/metadata',
    FILTER: 'master/FadvApiPackage/filter',
    BY_ID: (id) => `master/FadvApiPackage/${encodeURIComponent(String(id ?? "").trim())}`,
}

/** Client Plan master — metadata, filter, CRUD */
export const CLIENT_PLAN = {
    LIST: 'master/ClientPlan',
    METADATA: 'master/ClientPlan/metadata',
    FILTER: 'master/ClientPlan/filter',
    BY_ID: (id) => `master/ClientPlan/${encodeURIComponent(String(id ?? "").trim())}`,
}
export const SOURCE = {
    GET_SOURCE_LIST : 'master/Source',
    ADD_SOURCE : 'master/Source',
    GET_JOB_SOURCE_SCHEMA: 'master/Source/metadata',
    SUBMIT_FILTER_DATA: 'master/Source/filter',
}
export const USER = {
    GET_DEFAULT_USER_LIST : 'User/system/filter',
    /** POST `User` — create user. */
    CREATE: 'User/system',
    /** GET `User/{id}` — detail; PUT update user. */
    BY_ID: (id) => {
        const raw = String(id ?? "").trim();
        return `User/system/${encodeURIComponent(raw)}`;
    },
}

export const USER_ACTIVITY = {
    CHART: 'User/UserActivity/chart',
    SUMMARY_FILTER: 'User/UserActivity/summary/filter',
    SESSIONS_FILTER: 'User/UserActivity/sessions/filter',
}
/** List / filter users under system admin (`User/system/*`). */
export const USER_SYSTEM = {
    METADATA: 'User/system/metadata',
    FILTER: 'User/system/filter',
    /** GET/PUT `User/system/{userId}/client-access` */
    CLIENT_ACCESS: (userId) => {
        const raw = String(userId ?? "").trim();
        return `User/system/${encodeURIComponent(raw)}/client-access`;
    },
    /** GET/PUT `User/system/{userId}/client-temp-access` */
    CLIENT_TEMP_ACCESS: (userId) => {
        const raw = String(userId ?? "").trim();
        return `User/system/${encodeURIComponent(raw)}/client-temp-access`;
    },
    /** GET/PUT `User/system/{userId}/extra-permissions` */
    EXTRA_PERMISSIONS: (userId) => {
        const raw = String(userId ?? "").trim();
        return `User/system/${encodeURIComponent(raw)}/extra-permissions`;
    },
    /** POST `User/system/{userId}/reset-block` */
    RESET_BLOCK: (userId) => {
        const raw = String(userId ?? "").trim();
        return `User/system/${encodeURIComponent(raw)}/reset-block`;
    },
}

/** Per-user key/value settings (e.g. table column order + visibility). */
export const USER_SETTING = {
    /** GET — list all settings; PUT — upsert `{ settingsKey, settingsValue }`. */
    LIST: "user/UserSetting",
    UPDATE: "user/UserSetting",
    /** GET — fetch one setting by key. */
    BY_KEY: (settingsKey) =>
        `user/UserSetting?settingsKey=${encodeURIComponent(String(settingsKey ?? "").trim())}`,
}

export const REPORT = {
    USER_CLIENT_ACTIVITY: 'Report/user-client-activity',
    LEADS_ADDED_FILTER: 'Report/leads-added/filter',
    LEADS_ADDED_STATUS_CANDIDATES_FILTER: 'Report/leads-added/status-candidates/filter',
    CLIENT_USER_FILTER: 'Report/client-user/filter',
    /** GET — client user report table columns + filter schema. */
    CLIENT_USER_METADATA: 'Report/client-user/metadata',
    CLIENT_USER_ACTIVITY: (clientId) => {
        const raw = String(clientId ?? "").trim();
        return `Report/client-user/activity/${encodeURIComponent(raw)}`;
    },
    READY_TO_SEND_FILTER: 'Report/ready-to-send/filter',
    READY_TO_SEND_BY_ID: (id) => {
        const raw = String(id ?? "").trim();
        return `Report/ready-to-send/${encodeURIComponent(raw)}`;
    },
    CLIENT_STATUS_FILTER: 'Report/client-status/filter',
    IN_PROGRESS_FILTER: 'Report/in-progress/filter',
    IN_PROGRESS_SEND: 'Report/in-progress/send',
    RTR_INTERNAL_FILTER: 'Report/rtr-internal/filter',
    RTR_INTERNAL_SCHEDULE: 'Report/rtr-internal/schedule',
    ELIGIBLE_FILTER: 'Report/eligible/filter',
    CANDIDATE_SUMMARY_FILTER: 'Report/candidate-summary/filter',
    CANDIDATE_SUMMARY_SEND: 'Report/candidate-summary/send',
    CLOSURE_FILTER: 'Report/closure/filter',
    CLIENT_FILTER: 'Report/client/filter',
    CLIENT_SEND: 'Report/client/send',
    /** GET — client report report type dropdown. */
    CLIENT_OPTIONS_REPORT_TYPE: 'Report/client/options/report-type',
    /** GET — client report client dropdown. */
    CLIENT_OPTIONS_CLIENTS: 'Report/client/options/clients',
    /** GET — client report submit action dropdown. */
    CLIENT_OPTIONS_SUBMIT_ACTION: 'Report/client/options/submit-action',
    TEAM_PERFORMANCE_FILTER: 'Report/team-performance/filter',
    BACKEND_PERFORMANCE_FILTER: 'Report/backend-performance/filter',
    SEGMENT_COMPLETION_FILTER: 'Report/segment-completion/filter',
    DRUG_CSV_ACTIVITY: 'Report/drug-csv-activity',
    SESSION_ACTIVITY: 'Report/session',
    NOT_INTERESTED_FILTER: 'Report/not-interested/filter',
    MONTH_SUMMARY_YEARS: 'Report/month-summary/years',
    MONTH_SUMMARY_DOWNLOAD: 'Report/month-summary/download',
    SME_PERFORMANCE_FILTER: 'Report/sme-performance/filter',
    CALLER_PERFORMANCE_FILTER: 'Report/caller-performance/filter',
    AI_FADV_USER_WISE_CLIENT_FILTER: 'Report/ai-fadv-user-wise-client/filter',
    AI_FADV_USER_WISE_CLIENT_METADATA: 'Report/ai-fadv-user-wise-client/metadata',
    AI_FADV_USER_WISE_CLIENT_CLIENTS_FILTER: 'Report/ai-fadv-user-wise-client/clients/filter',
}
export const USER_TEAM = {
    GET_TEAM_LIST: 'user/Team',
    GET_TEAM_SCHEMA: 'user/Team/metadata',
    SUBMIT_FILTER_DATA: 'user/Team/filter',
    UPSERT_TEAM: 'user/Team/upsert',
}
/** Company-scoped users (`user/company/*`). */
export const USER_COMPANY = {
    METADATA: 'user/company/metadata',
    FILTER: 'user/company/filter',
    /** GET `user/company/{userId}` — company user detail for edit */
    BY_ID: (userId) => {
        const raw = String(userId ?? "").trim();
        return `user/company/${encodeURIComponent(raw)}`;
    },
    /** POST `user/company/{companyId}/user` — create */
    CREATE: (companyId) => {
        const raw = String(companyId ?? "").trim();
        return `user/company/${encodeURIComponent(raw)}/user`;
    },
    /** PUT `user/company/{companyId}/user/{userId}` — update */
    UPDATE: (companyId, userId) => {
        const c = String(companyId ?? "").trim();
        const u = String(userId ?? "").trim();
        return `user/company/${encodeURIComponent(c)}/user/${encodeURIComponent(u)}`;
    },
    /** DELETE `user/{userId}/company/{companyId}` */
    DELETE: (userId, companyId) => {
        const u = String(userId ?? "").trim();
        const c = String(companyId ?? "").trim();
        return `user/${encodeURIComponent(u)}/company/${encodeURIComponent(c)}`;
    },
    /** GET `user/company/{companyId}/clients` — assignable clients for company user form */
    CLIENTS: 'user/company',
    /** GET `user/company/user-type-options` — user type dropdown (company user add/edit). */
    USER_TYPE_OPTIONS: 'user/company/user-type-options',
}
export const MASTER_PERMISSION = {
    LIST: 'master/Permission',
}
export const USER_TYPE = {
    GET_METADATA: 'user/UserType/metadata',
    SUBMIT_FILTER_DATA: 'user/UserType/filter',
    /** Collection + upsert (same pattern as `user/Team`). */
    GET_LIST: 'user/UserType',
}
export const USER_WORK_SHIFT = {
    GET_WORK_SHIFT_LIST: 'user/WorkShift',
    GET_WORK_SHIFT_SCHEMA: 'user/WorkShift/metadata',
    SUBMIT_FILTER_DATA: 'user/WorkShift/filter',
    UPSERT_WORK_SHIFT: 'user/WorkShift/upsert',
}
export const USER_WARNING_LETTER = {
    GET_WARNING_LETTER_LIST: 'user/WarningLetter',
    GET_WARNING_LETTER_SCHEMA: 'user/WarningLetter/metadata',
    SUBMIT_FILTER_DATA: 'user/WarningLetter/filter',
    UPSERT_WARNING_LETTER: 'user/WarningLetter/upsert',
}
export const USER_ATTENDANCE = {
    METADATA: 'user/Attendance/metadata',
    FILTER: 'user/Attendance/filter',
    RESET: 'user/Attendance/reset',
}

/** User notification inbox — recent dropdown + full list. */
export const USER_NOTIFICATIONS = {
    RECENT: 'user/notifications/recent',
    METADATA: 'user/notifications/metadata',
    FILTER: 'user/notifications/filter',
    READ: (id) => `user/notifications/${encodeURIComponent(String(id ?? "").trim())}/read`,
}

export const REASON = {
    GET_REASON_LIST : 'master/Reasons',
    ADD_REASON : 'master/Reasons',
    GET_JOB_REASON_SCHEMA: 'master/Reasons/metadata',
    SUBMIT_FILTER_DATA: 'master/Reasons/filter',
    COMMON_REASONS: 'common/not-interested-sub-status',
    COMMON_REASONS_FOR_ALL: 'common/reasons',
}
export const JOB = {
    GET_JOB_LIST : 'master/Job',
    ADD_JOB : 'master/Job',
    GET_JOB_SCHEMA: 'master/Job/metadata',
    SUBMIT_FILTER_DATA: 'master/Job/filter',
    SUBMIT_PACKAGE_FILTER_DATA: 'master/Package/filter',
    SUBMIT_AI_JOB_TYPE_FILTER_DATA: 'master/AIJobType/filter',
}

export const DOC_REQUIRED = {
    GET_DOC_REQUIRED_LIST : 'master/DocumentRequired',
    ADD_DOC_REQUIRED : 'master/DocumentRequired',
    GET_DOC_REQUIRED_SCHEMA: 'master/DocumentRequired/metadata',
    SUBMIT_FILTER_DATA: 'master/DocumentRequired/filter',
}

export const ONBOARDING_DOCUMENTS = {
    LIST: 'master/onboarding-documents',
    METADATA: 'master/onboarding-documents/metadata',
    SUBMIT_FILTER_DATA: 'master/onboarding-documents/filter',
}

export const CANDIDATE_ONBOARDING = {
    METADATA: 'candidate/onboarding/meta',
    FILTER: 'candidate/onboarding/filter',
    ONBOARDING_STATUS_OPTIONS: 'candidate/onboarding/options/onboarding-status',
    /** GET onboarding documents for a candidate onboarding row. */
    DOCUMENTS_BY_ID: (id) =>
        `candidate/onboarding/${encodeURIComponent(String(id ?? '').trim())}`,
}

export const TASK_BUCKET = {
    GET_TASK_BUCKET_LIST: 'master/TaskBucket',
    ADD_TASK_BUCKET: 'master/TaskBucket',
    GET_TASK_BUCKET_SCHEMA: 'master/TaskBucket/metadata',
    SUBMIT_FILTER_DATA: 'master/TaskBucket/filter',
    GET_TASK_BUCKET_GROUP_LIST: 'master/TaskBucketGroup',
}

export const TASK_PLANNER = {
    TASK_PLANNER_LIST: 'task-planner',
    TASK_PLANNER_FILTER: 'task-planner/filter',
    TASK_PLANNER_FOR_EDIT: 'task-planner/for-edit',
    TASK_PLANNER_ASSIGNED: 'task-planner/assigned',
    TASK_PLANNER_ASSIGNED_SEARCH: 'task-planner/assigned/search',
    TASK_PLANNER_COMMENT: 'task-planner/comment',
    GET_TASK_PLANNER_COMMENT: 'task-planner/comments',
    TASK_PLANNER_STATUS: 'common/task-planner-status',
    TASK_PLANNER_PRIORITY: 'common/task-planner-priority',
}

export const TWILIO_PHONE = {
    GET_TWILIO_PHONE_LIST: 'master/twilio-phone-number',
    ADD_TWILIO_PHONE: 'master/twilio-phone-number',
    GET_TWILIO_PHONE_SCHEMA: 'master/twilio-phone-number/metadata',
    SUBMIT_FILTER_DATA: 'master/twilio-phone-number/filter',
    BY_ID: (phoneId) => {
        const raw = String(phoneId ?? "").trim();
        return `master/twilio-phone-number/${encodeURIComponent(raw)}`;
    },
}

export const COMPANY = {
    GET_COMPANY_LIST: 'client/Company',
    ADD_COMPANY: 'client/Company',
    GET_COMPANY_SCHEMA: 'client/Company/metadata',
    SUBMIT_FILTER_DATA: 'client/Company/filter',
}

export const CANDIDATE = {
    SUBMIT_FILTER_DATA: 'Candidate/filter',
    /** POST — global header candidate search (`{ nameContains }`). */
    HEADER_SEARCH: 'Candidate/header-search',
    GET_METADATA: 'Candidate/metadata',
    GET_CANDIDATE: 'Candidate',
    ADD_CANDIDATE: 'Candidate',
    UPDATE_CANDIDATE: 'Candidate',
    TRANSFER_CANDIDATE: 'Candidate/Transfer',
    /** POST — bulk transfer selected candidates `{ ids: string[], clientId: string }`. */
    BULK_TRANSFER: 'Candidate/bulk-transfer',
    /** POST — bulk move selected candidates `{ candidateClientIds: string[], targetClientId: string, jobId: string }`. */
    BULK_MOVE: 'Candidate/bulk-move',
    DEACTIVATE: 'Candidate/deactive',
    TODAY_CALL: (candidateId) => `Candidate/${candidateId}/add-today-call`,
    SURE_MAIL_SEND: (candidateId) => `Candidate/${candidateId}/reset-mail-send`,
    CLOSURE: (id) => `Candidate/closure/${id}`,
    CLOSURE_SUBMIT: (id) => `Candidate/${id}/closure`,
    MARK_AS_HIRED: (id) => `Candidate/${id}/mark-hired`,
    MARK_AS_REJECTED: (id) => `Candidate/${id}/mark-reject`,
    /** POST `Candidate/{candidateClientId}/ai-recruiter-opt-in` */
    AI_RECRUITER_OPT_IN: (candidateClientId) =>
        `Candidate/${encodeURIComponent(String(candidateClientId ?? "").trim())}/ai-recruiter-opt-in`,
    /** POST `Candidate/{candidateClientId}/ai-recruiter-opt-out` — body `{ notes }` */
    AI_RECRUITER_OPT_OUT: (candidateClientId) =>
        `Candidate/${encodeURIComponent(String(candidateClientId ?? "").trim())}/ai-recruiter-opt-out`,
    /** GET `Candidate/clients/{clientId}/jobs` — jobs for Position Applied on candidate add/edit */
    GET_CLIENT_JOBS: (clientId) => `Candidate/clients/${clientId}/jobs`,
    /**
     * Base path for candidate work experience (same URL style as job category: `${GET_WORK_EXPERIENCE}/${id}`).
     * Example: `candidate/WorkExperience/{candidateId}` where `candidateId` is e.g. `item.candidateId`.
     */
    GET_WORK_EXPERIENCE: "candidate/WorkExperience",
}

/** Hire status list + upsert (POST body). */
export const HIRE_STATUS = {
    GET_METADATA: "HireStatus/meta",
    SUBMIT_FILTER_DATA: "HireStatus/filter",
    UPSERT: "HireStatus",
    /** GET — hire status filter multiselect (`get_hire_status_hire_status_options`) */
    GET_OPTIONS: "common/hire-status-hire-status",
    /** GET — client paid filter dropdown (`get_hire_status_client_paid_options`) */
    GET_CLIENT_PAID_OPTIONS: "HireStatus/options/client-paid",
    /** GET — incentive status (hire status table + add/edit modal) */
    GET_INCENTIVE_STATUS_OPTIONS: "HireStatus/options/incentive-status",
}

export const CANDIDATE_CALLBACK = {
    GET_METADATA: "candidate/callback/meta",
    SUBMIT_FILTER_DATA: "candidate/callback/filter",
    SUBMIT: (id = "") =>
        `candidate/callback${String(id || "").trim() ? `/${String(id).trim()}` : ""}`,
}

/** Verify application file — metadata + filter */
export const VERIFY_APPLICATION_FILE = {
    GET_METADATA: "candidate/verify-application-file/metadata",
    SUBMIT_FILTER_DATA: "candidate/verify-application-file/filter",
    SUBMIT: "candidate/verify-application-file/submit",
}

/** FADV CSV log list — metadata + filter */
export const CANDIDATE_CSV = {
    GET_METADATA: "candidate/csv/meta",
    SUBMIT_FILTER_DATA: "candidate/csv/filter",
    /** GET — profile CSV upload page metadata. */
    PROFILE_METADATA: "candidate/csv/profileCSV/metadata",
    /** POST multipart — `{ ClientId, File }`. */
    PROFILE_UPLOAD: "candidate/csv/profileCSV/upload",
    /** POST — `{ clientId, data: [...] }`. */
    PROFILE_VERIFY: "candidate/csv/profileCSV/verify",
    DRUG_UPLOAD: "candidate/csv/drugCSV/upload",
    DRUG_VERIFY: "candidate/csv/drugCSV/verify",
    FADV_VERIFY: "candidate/csv/fadv/verify",
    FADV_VERIFY_METADATA: "candidate/csv/fadv/verify/metadata",
    FADV_SUBMIT: "candidate/csv/fadv/submit",
    CANDIDATE_AUTOCOMPLETE: "candidate/csv/candidate-autocomplete",
    BULK_CV_UPLOAD: "candidate/csv/bulk-cv/upload",
}

/** FADV order log — metadata, filter, trigger API */
export const CANDIDATE_FADV = {
    GET_METADATA: "candidate/fadv/meta",
    SUBMIT_FILTER_DATA: "candidate/fadv/filter",
    TRIGGER_FADV: (id) => `candidate/fadv/${id}/trigger-fadv`,
}

/** FADV profile order log — metadata, filter, trigger API */
export const CANDIDATE_FADV_PROFILE = {
    GET_METADATA: "candidate/fadv/profile/meta",
    SUBMIT_FILTER_DATA: "candidate/fadv/profile/filter",
    TRIGGER_FADV: (fadvProfileOrderDataId) =>
        `candidate/fadv/profile/${encodeURIComponent(String(fadvProfileOrderDataId ?? "").trim())}/trigger`,
}

/** Block FADV requestor — metadata, filter, toggle blocked */
export const BLOCK_FADV_REQUESTOR = {
    GET_METADATA: "candidate/fadv/blocked-requestors/metadata",
    SUBMIT_FILTER_DATA: "candidate/fadv/blocked-requestors/filter",
    TOGGLE_BLOCKED: "candidate/fadv/blocked-requestors/toggle",
}

/** Account executive weekly review (dashboard). */
export const ACCOUNT_EXECUTIVE_DASHBOARD = {
    HOME: "dashboard/account-executive",
    META: "dashboard/account-executive/meta",
}

/** Recruiter dashboard. */
export const RECRUITER_DASHBOARD = {
    HOME: "dashboard/recruiter",
    VIEW_AS_OPTIONS: "dashboard/recruiter/view-as-options",
}

/** Backend dashboard. */
export const BACKEND_DASHBOARD = {
    HOME: "dashboard/backend",
    VIEW_AS_OPTIONS: "dashboard/backend/view-as-options",
    DETAILS: (id) =>
        `dashboard/backend/details/${encodeURIComponent(String(id ?? "").trim())}`,
}

/** AI pipeline dashboard. */
export const AI_PIPELINE_DASHBOARD = {
    SUMMARY_FILTER: "dashboard/ai-pipeline/summary/filter",
    SUMMARY_DETAIL_FILTER: "dashboard/ai-pipeline/summary-detail/filter",
    CLIENT_PIPELINE_FILTER: "dashboard/ai-pipeline/client-pipeline/filter",
    NEEDS_ATTENTION_FILTER: "dashboard/ai-pipeline/needs-attention/filter",
}

/** Shared dropdown APIs used by multiple forms. */
export const COMMON = {
    INTERVIEW_LINK: "common/interview-link",
    CLIENT_COMPANY: "common/client-company",
    /** POST — company autocomplete (`{ nameContains }`). */
    COMPANY_AUTOCOMPLETE: "common/company-autocomplete",
    /** POST V2 — async client filter select (`AsyncClientSelect`), body `{ pageName, nameContains }`. */
    CLIENT: "common/client",
    /** POST — async user filter select (`AsyncUserSelect`), body `{ pageName, search }`. */
    SYSTEM_USERS: "common/system-users",
    TWILIO_PHONE: "common/twilio-phone",
    TIMEZONE: "common/timezone",
    PERSONALITY_TEST_LINK: "common/personality-test-link",
    ORDER_STATUS: "common/order-status",
    /** GET — candidate hire status table / filter status dropdown. */
    HIRE_STATUS: "common/hire-status-hire-status",
    /** Yes / No style dropdowns (shared with filters). */
    YES_NO: "common/yes-no",
    INCENTIVE_TYPE: "common/incentive-type",
    /** Work shift options for user forms. */
    WORK_SHIFT: "common/work-shift",
    /** Status options (user forms, filters). */
    STATUS: "common/status",
    /** Client Review status options — filter metadata `get_client_review_status_options`. */
    CLIENT_REVIEW_STATUS: "common/client-review-status",
    /** Status badge colors / tones for tables (`data.items[]` with groupKey, key, backgroundColor, textColor). */
    STATUS_METADATA: "common/status-metadata",
    /** Call status options — Call Details notes tab. */
    CALL_STATUS: "common/call-status",
    /** POST merged call status options when candidate profile is complete. */
    CALL_STATUS_MERGE: "common/call-status-merge",
    /** GET — Call Executive Today filter modal call status options. */
    CALL_STATUS_TWO: "common/call-status-two",
    /** GET V2 — Plan options `{ id, display }[]` — client register, onboarding forms (`api/v2/common/plan`). */
    PLAN: "common/plan",
    /** FADV package `{ id, display }[]` — Call Details Application Status / Job AI package. */
    FADV_PACKAGE: "common/fadv-package",
    /** FADV multi-select package options — Master Job `{ primaryIds, selected }`. */
    FADV_PACKAGE_MULTI: "common/fadv-package-multi",
    /** Drug test / screening status options — Call Details candidate test update modal. */
    DRUG_STATUS: "common/drug-status",
    /** GET `common/attachments/{attachmentId}` — resolves signed/public URL for download. */
    ATTACHMENT_BY_ID: (attachmentId) =>
        `call/details/attachments/${encodeURIComponent(String(attachmentId ?? "").trim())}`,
    /** Block status filter + user status `{ id, display }` (e.g. "", "false", "true"). */
    USER_BLOCK_STATUS: "common/user-block-status",
    NOTIFICATION_TYPE: "common/notification-type",
    /** GET — AI Recruiter log notification type filter (`get_airecruiter_notification_types`). */
    AI_RECRUITER_NOTIFICATION_TYPES: "common/ai-recruiter-notification-types",
    /** GET — notification settings "Settings For" dropdown options. */
    NOTIFICATION_SETTINGS_FOR: "common/notification-settings-for",
    /** POST — job dropdown options (filters, job description toolbar, etc.). */
    JOB: "common/job",
    /** GET — job category dropdown options. */
    JOB_CATEGORY: "common/job-category",
    /** GET — client source dropdown options. */
    CLIENT_SOURCE: "common/client-source",
    /** GET — source dropdown options (`AsyncSourceSelect`). */
    SOURCE: "common/source",
    /** POST V2 — team dropdown options, body `{ pageName }`. */
    TEAM: "common/team",
    /** GET — attendance status dropdown options (Attendance Report filter). */
    ATTENDANCE_STATUS: "common/attendance-status",
    /** GET — report mail source dropdown (`{ id, display }`). */
    REPORT_MAIL_SOURCE: "common/report-mail-source",
    /** GET — in-progress report client async select. */
    IN_PROGRESS_CLIENTS: "common/in-progress/clients",
    /** GET — account executive users `{ id, display }[]` — onboarding account owner dropdown. */
    ACCOUNT_EXECUTIVE_USERS: "common/account-executive-users",
    /** GET — user type dropdown options (manage user add/edit). */
    USER_TYPE: "common/user-type",
    /** GET — bad fit resolution reason dropdown options (Call Details modal). */
    BAD_FIT_RESOLUTION_REASONS: "common/bad-fit-resolution-reasons",
}

/** AI Recruiter log list — table metadata + paged filter. */
export const AI_RECRUITER_LOG = {
    GET_METADATA: "ai-recruiter/metadata",
    SUBMIT_FILTER_DATA: "ai-recruiter/logs/filter",
}

/** AI Recruiter call scheduled report — table metadata + date-range filter. */
export const CALL_SCHEDULED_REPORT = {
    GET_METADATA: "ai-recruiter/call-scheduled-report/metadata",
    SUBMIT_FILTER_DATA: "ai-recruiter/call-scheduled-report/filter",
}

/** AI Recruiter call actions (e.g. trigger from Call Details). */
export const AI_RECRUITER = {
    /** POST body: `{ candidateClientId, status, aiAddOnCallTemplateId }`. */
    CALL_TRIGGER_POST: "ai-recruiter/call/trigger",
    /** GET `ai-recruiter/call/trigger?candidateClientId=` — AI call trigger status for a candidate. */
    CALL_TRIGGER_STATUS: (candidateClientId) =>
        `ai-recruiter/call/trigger?candidateClientId=${encodeURIComponent(String(candidateClientId ?? "").trim())}`,
    /** POST body: `{ ids: string[] }` — move selected candidates to AI recruiter schedule. */
    MOVE_TO_SCHEDULE: "ai-recruiter/move-to-schedule",
}

/** AI Recruiter bad fit resolution (Call Details toolbar). */
export const BAD_FIT = {
    GET_METADATA: "ai-recruiter/bad-fit/metadata",
    SUBMIT_FILTER_DATA: "ai-recruiter/bad-fit/filter",
    /** GET `ai-recruiter/bad-fit/tracking/{trackingId}` — bad fit tracking details. */
    TRACKING_BY_ID: (trackingId) =>
        `ai-recruiter/bad-fit/tracking/${encodeURIComponent(String(trackingId ?? "").trim())}`,
    /** POST body: `{ badFitResolutionReasonMasterId, note }`. */
    RESOLVE: (candidateClientId) =>
        `ai-recruiter/bad-fit/${encodeURIComponent(String(candidateClientId ?? "").trim())}/resolve`,
}

/** Driver details per candidate: GET/POST `DriverDetails/{candidateId}` */
export const DRIVER_DETAILS = {
    BY_CANDIDATE_ID: (candidateId) => `DriverDetails/${candidateId}/for-edit`,
    UPDATE_BY_CANDIDATE_ID: (candidateId) => `DriverDetails/${candidateId}`,

}

/** Verify Test list + actions (IDs in URL for approve/cancel). */
export const VERIFY_TEST = {
    GET_METADATA: 'Candidate/verify-test/metadata',
    SUBMIT_FILTER_DATA: 'Candidate/verify-test/filter',
    APPROVE: (id) => `Candidate/verify-test/${id}/approve`,
    CANCEL: (id) => `Candidate/verify-test/${id}/cancel`,
}

/** Candidate closure list (modify closure page). */
export const CANDIDATE_CLOSURE = {
    GET_METADATA: "Candidate/closure/metadata",
    SUBMIT_FILTER_DATA: "Candidate/closure/filter",
    DELETE: (id) => `Candidate/closure/${encodeURIComponent(String(id ?? "").trim())}`,
}

/** Call audit list — table metadata + paged filter (upper bar matches verify-test). */
export const AUDIT_CALL = {
    GET_METADATA: "Audit/metadata",
    SUBMIT_FILTER_DATA: "Audit/filter",
    CREATE_BATCH_DATE_RANGE: "Audit/create-batch/date-range",
    CREATE_BATCH: "Audit/create-batch",
    FOR_EDIT: (auditId) => `Audit/${auditId}/for-edit`,
    UPDATE: (auditId) => `Audit/${auditId}`,
    FILES: (auditId) => `Audit/${auditId}/files`,
}

/** Call executive — scheduled list (metadata + paged filter). */
export const CALL_EXECUTIVE = {
    GET_METADATA: "CallExecutive/scheduled/metadata",
    SUBMIT_SCHEDULED_FILTER: "CallExecutive/scheduled/filter",
    GET_TODAY: "CallExecutive/today/metadata",
    SUBMIT_TODAY_FILTER: "CallExecutive/today/filter",
    GET_WRONG_NUMBER_METADATA: "CallExecutive/wrong-number/metadata",
    SUBMIT_WRONG_NUMBER_FILTER: "CallExecutive/wrong-number/filter",
    GET_IN_PROGRESS_METADATA: "CallExecutive/in-progress/metadata",
    SUBMIT_IN_PROGRESS_FILTER: "CallExecutive/in-progress/filter",
    GET_UNDER_AGE_METADATA: "CallExecutive/under-age/metadata",
    SUBMIT_UNDER_AGE_FILTER: "CallExecutive/under-age/filter",
    GET_INTERVIEW_METADATA: "CallExecutive/interview/metadata",
    SUBMIT_INTERVIEW_FILTER: "CallExecutive/interview/filter",
    GET_NOT_ON_AI_METADATA: "CallExecutive/not-on-ai/metadata",
    SUBMIT_NOT_ON_AI_FILTER: "CallExecutive/not-on-ai/filter",
    /** POST `CallExecutive/today/quick-update` — body `{ candidateClientId, value }`. */
    UPDATE_CALL_QUICK_UPDATE: "CallExecutive/today/quick-update",
    GET_MY_CALL_METADATA: "call/my-calls/metadata",
    SUBMIT_MY_CALL_FILTER: "call/my-call/filter",
    GET_DEACTIVE_METADATA: "call/deactive/metadata",
    SUBMIT_DEACTIVE_FILTER: "call/deactive/filter",
    GET_RTR_ACKNOWLEDGE_METADATA: "call/rtr-acknowledge/metadata",
    SUBMIT_RTR_ACKNOWLEDGE_FILTER: "call/rtr-acknowledge/filter",
    /** PUT `call/rtr-acknowledge/{id}` — body `{ notes, acknowledgeType }` (`yes` / `no`) or `{ notes }` (notes blur).
     *  DELETE `call/rtr-acknowledge/{id}` — remove acknowledgement record. */
    RTR_ACKNOWLEDGE_SUBMIT: (id) =>
        `call/rtr-acknowledge/${encodeURIComponent(String(id ?? "").trim())}`,
}

/** Call manager — Order In Progress (OIP) + Order Eligible (OE) lists. */
export const CALL_MANAGER = {
    GET_OIP_METADATA: "call/manager/oip/metadata",
    SUBMIT_OIP_FILTER: "call/manager/oip/filter",
    /** POST `call/manager/{id}/mark-eligible` — mark a candidate eligible. */
    OIP_MARK_ELIGIBLE: (id) =>
        `call/manager/${encodeURIComponent(String(id ?? "").trim())}/mark-eligible`,
    GET_OE_METADATA: "call/manager/oe/metadata",
    SUBMIT_OE_FILTER: "call/manager/oe/filter",
    GET_FR_METADATA: "call/manager/fr/metadata",
    SUBMIT_FR_FILTER: "call/manager/fr/filter",
    /** POST `call/manager/{id}/resolved` — resolve a further-review candidate (body `{ orderStatus, reasonsId }`). */
    FR_RESOLVED: (id) =>
        `call/manager/${encodeURIComponent(String(id ?? "").trim())}/resolved`,
}

/** Call details page — quota modals. */
export const CALL_DETAILS = {
    FEDEX_CANDIDATE_GET: (candidateId) =>
        `call/details/fedex-candidate/${encodeURIComponent(String(candidateId ?? "").trim())}`,
    /** POST body: candidateClientId, fedexId, contactorName, terminalAddress, reasonForLeaving */
    FEDEX_EXISTING_DRIVER_POST: "call/details/fedex-candidate",
    /** PUT body: { value: string } */
    EMAIL: (callDetailsId) =>
        `call/details/${encodeURIComponent(String(callDetailsId ?? "").trim())}/email`,
    /** PUT body: { value: string } */
    FEDEX_ID: (callDetailsId) =>
        `call/details/${encodeURIComponent(String(callDetailsId ?? "").trim())}/fedex-id`,
    /** Path segment is **candidateId** (not candidateClientId). */
    CANDIDATE_TESTS_GET: (candidateId) =>
        `call/details/${encodeURIComponent(String(candidateId ?? "").trim())}/candidate-tests`,
    /**
     * Candidate-test action URL from `actions[].routeKey` (and optional `routeArgument`).
     * When `routeKey` already begins with `call/` (e.g. `call/details/.../candidate-test`), it is used as-is
     * so paths are not doubled as `call/details/{id}/call/details/...`.
     * Otherwise: `call/details/{candidateId}/{routeKey}` plus optional `/{routeArgument}`.
     */
    CANDIDATE_TEST_ACTION_REQUEST: (candidateId, routeKey, routeArgument) => {
        const rk = String(routeKey ?? "")
            .trim()
            .replace(/^\/+/, "")
            .replace(/\/+$/, "");
        if (!rk) return "";
        const trimmedArgument = routeArgument == null ? "" : String(routeArgument).trim();

        let basePath;
        if (/^(call|candidate)\//i.test(rk)) {
            basePath = rk;
        } else {
            const safeCallDetailsId = encodeURIComponent(String(candidateId ?? "").trim());
            basePath = `call/details/${safeCallDetailsId}/${rk}`;
        }
        if (!trimmedArgument) return basePath;
        return `${basePath}/${encodeURIComponent(trimmedArgument)}`;
    },
    /** POST body: candidateClientId, callStatusType, notes, scheduleDateAndTime, specialNotes, optional reasonId (Not interested), optional drugTestAndDotCompletionDate (completed). */
    CALL_STATUS_POST: "call/details/call-activities",
    /** POST body: `{ id, videoLink, interviewDate }`. */
    INTERVIEW_VIDEO_LINK_POST: "call/details/interview-video-link",
    /** GET `call/details/{callDetailsId}/interview-video-link` — existing video interview link. */
    INTERVIEW_VIDEO_LINK_GET: (callDetailsId) =>
        `call/details/${encodeURIComponent(String(callDetailsId ?? "").trim())}/interview-video-link`,
    GET_CALL_INFO: "call/details",
    /** GET `call/details/transcript/{aiCallTranscriptId}` — AI recruiter call transcript messages. */
    CALL_TRANSCRIPT_GET: (aiCallTranscriptId) =>
        `call/details/transcript/${encodeURIComponent(String(aiCallTranscriptId ?? "").trim())}`,
    /** GET `call/details/{callDetailsId}/conversation` — SMS / chat conversation for Call Details. */
    CONVERSATION_GET: (callDetailsId) =>
        `call/details/${encodeURIComponent(String(callDetailsId ?? "").trim())}/conversation`,
    /** POST `call/details/{callDetailsId}/conversation` — send conversation message. Body: `{ message }`. */
    CONVERSATION_POST: (callDetailsId) =>
        `call/details/${encodeURIComponent(String(callDetailsId ?? "").trim())}/conversation`,
    /** POST `call/details/{callDetailsId}/conversation/render-template` — render template HTML. Body: `{ templateId }`. */
    CONVERSATION_RENDER_TEMPLATE_POST: (callDetailsId) =>
        `call/details/${encodeURIComponent(String(callDetailsId ?? "").trim())}/conversation/render-template`,
    /** GET `call/details/{callDetailsId}/ai-call-scheduled` — AI call schedule history for Call Details modal. */
    AI_CALL_SCHEDULED_GET: (callDetailsId) =>
        `call/details/${encodeURIComponent(String(callDetailsId ?? "").trim())}/ai-call-scheduled`,
    /** POST `call/details/{candidateClientId}/road-test` — same path as `ROAD_TEST_SCHEDULE_GET`. */
    ROAD_TEST_SCHEDULE_POST: (candidateClientId) =>
        `call/details/${encodeURIComponent(String(candidateClientId ?? "").trim())}/road-test`,
    /** GET `call/details/{candidateClientId}/road-test` — road test schedule / details for Call Details modal. */
    ROAD_TEST_SCHEDULE_GET: (candidateClientId) =>
        `call/details/${encodeURIComponent(String(candidateClientId ?? "").trim())}/road-test`,
    /** GET `call/details/{callDetailsId}/pre-screening` — pre-screening Q&A for Call Details. */
    PRE_SCREENING_GET: (candidateClientId) =>
        `call/details/${encodeURIComponent(String(candidateClientId ?? "").trim())}/pre-screening`,
    /** GET `call/details/{callDetailsId}/client-info` — Client Info tab (contacts, FADV, sections). */
    CLIENT_INFO_GET: (callDetailsId) =>
        `call/details/${encodeURIComponent(String(callDetailsId ?? "").trim())}/client-info`,
    /** POST body: `{ candidateClientId, items: [{ questionKey, existingAnswerId, title, value, forFunnl }] }`. */
    PRE_SCREENING_POST: "call/details/pre-screening",
    /** GET `call/fadv/{candidateClientId}` — FADV panel for Application Status. */
    FADV_PANEL_GET: (candidateClientId) =>
        `call/fadv/${encodeURIComponent(String(candidateClientId ?? "").trim())}`,
    /** POST `call/fadv/package/status/{candidateClientId}` — FADV package status reload. */
    FADV_PACKAGE_STATUS_POST: (candidateClientId) =>
        `call/fadv/package/status/${encodeURIComponent(String(candidateClientId ?? "").trim())}`,
    /** POST body: `{ candidateClientId, fadvApiId, email }`. */
    FADV_PACKAGE_SEND_POST: "call/fadv/package/send",
    /** POST body `{ value: string }` — send FADV link yes/no (path segment is `candidateClientId`). */
    FADV_SEND_LINK_POST: (candidateClientId) =>
        `call/fadv/${encodeURIComponent(String(candidateClientId ?? "").trim())}/send-link`,
    /** GET `call/fadv/driver-profile/image/{candidateClientId}` — driver details image row. */
    FADV_DRIVER_PROFILE_IMAGE_GET: (candidateClientId) =>
        `call/fadv/driver-profile/image/${encodeURIComponent(String(candidateClientId ?? "").trim())}`,
    /** POST `call/fadv/driver-profile/api/{candidateClientId}` — driver details send. */
    FADV_DRIVER_PROFILE_API_POST: (candidateClientId) =>
        `call/fadv/driver-profile/api/${encodeURIComponent(String(candidateClientId ?? "").trim())}`,
    /** GET `call/fadv/profile-details/background-image/{candidateClientId}` — reload background image. */
    FADV_PROFILE_BACKGROUND_IMAGE_RELOAD_GET: (candidateClientId) =>
        `call/fadv/profile-details/background-image/${encodeURIComponent(
            String(candidateClientId ?? "").trim()
        )}`,
    /** POST `call/fadv/profile-details/order-details/{candidateClientId}` — send order details. */
    FADV_PROFILE_ORDER_DETAILS_POST: (candidateClientId) =>
        `call/fadv/profile-details/order-details/${encodeURIComponent(
            String(candidateClientId ?? "").trim()
        )}`,
         /** GET `call/details/{candidateClientId}/road-test` — road test schedule / details for Call Details modal. */
    CALL_DETAILS_GET_TOOLBAR: (candidateClientId) =>
        `call/details/${encodeURIComponent(String(candidateClientId ?? "").trim())}/call-details-toolbar`,
}

export const FIND_COMPANY_USER = {
    GET_FIND_COMPANY_USER_LIST: 'client/company-user',
    GET_FIND_COMPANY_USER_SCHEMA: 'client/company-user/metadata',
    SUBMIT_FILTER_DATA: 'client/company-user/filter',
}

export const CLIENT_REGISTER = {
    GET_CLIENT_REGISTER_LIST: 'client/register',
    ADD_CLIENT_REGISTER: 'client/register',
    GET_CLIENT_REGISTER_SCHEMA: 'client/register/metadata',
    SUBMIT_FILTER_DATA: 'client/register/filter',
    GET_CLIENT_REGIS_LIST: 'client/Register',
    UPSERT_CLIENT_REGISTER_DATA: 'client/Register/upsert',
    GET_CLIENT_REGISTER_DOCUMENT_REQUIRED_ROWS: 'client/Register/document-required-rows',
    GET_CLIENT_REGISTER_JOB_REQUIRE_ROWS: 'client/Register/job-require-rows',
}

export const CLIENT_REVIEW = {
    GET_CLIENT_REVIEW_LIST: 'client/review',
    ADD_CLIENT_REVIEW: 'client/review',
    GET_CLIENT_REVIEW_SCHEMA: 'client/review/metadata',
    SUBMIT_FILTER_DATA: 'client/review/filter',
    GET_CLIENT_REVIEW_FOR_EDIT: (clientId) =>
        `client/review/for-edit/${encodeURIComponent(String(clientId ?? "").trim())}`,
    GET_CURRENT_WEEK_RANGE: 'client/review/get-current-week-range',
    ADD_CLIENT_UPSERT: 'client/review/upsert',
    GET_HIRE_CANDIDATES: (clientId) => `client/review/hire-candidates/${clientId}`,
}

export const CLIENT_SOURCE = {
    GET_CLIENT_SOURCE_LIST: 'client/ClientSource',
    ADD_CLIENT_SOURCE: 'client/ClientSource',
    GET_CLIENT_SOURCE_SCHEMA: 'client/ClientSource/metadata',
    SUBMIT_FILTER_DATA: 'client/ClientSource/filter',
}

export const CLIENT_PRE_QUESTION = {
    GET_CLIENT_PRE_QUESTION_LIST: 'client/ClientPreQuestion',
    ADD_CLIENT_PRE_QUESTION: 'client/ClientPreQuestion',
    GET_CLIENT_PRE_QUESTION_SCHEMA: 'client/ClientPreQuestion/metadata',
    SUBMIT_FILTER_DATA: 'client/ClientPreQuestion/filter',
    UPSERT_CLIENT_PRE_QUESTION: 'client/ClientPreQuestion/upsert',
    GET_CLIENT_PRE_QUESTION_FOR_EDIT: 'client/ClientPreQuestion/for-edit',
    RESET_MASTER_SORT: 'client/ClientPreQuestion',
    GET_JOB_BY_CLIENT: 'client/Register',
}

export const CLIENT_SECTION = {
    GET_CLIENT_LIST: 'Client',
    ADD_CLIENT: 'Client',
    GET_CLIENT_SCHEMA: 'Client/metadata',
    SUBMIT_FILTER_DATA: 'Client/filter',
    /** PUT `Client/{clientId}/status` — update client active/deactive status. */
    UPDATE_CLIENT_STATUS: (clientId) =>
        `Client/${encodeURIComponent(String(clientId ?? "").trim())}/status`,
}

export const CLIENT_JOB_DESCRIPTION = {
    GET_CLIENT_JOB_DESCRIPTION_LIST: 'client/clientJobDescription',
    GET_CLIENT_JOB_DESCRIPTION_SCHEMA: 'client/clientJobDescription/metadata',
    SUBMIT_FILTER_DATA: 'client/clientJobDescription/filter',
    UPSERT_CLIENT_JOB_DESCRIPTION: 'client/ClientJobDescription/upsert',
    GET_CLIENT_JOB_DESCRIPTION_FOR_EDIT: 'client/ClientJobDescription/for-edit',
    DELETE_CLIENT_JOB_DESCRIPTION: (id) =>
        `client/ClientJobDescription/${encodeURIComponent(String(id ?? "").trim())}`,
}

export const OFFBOARDING = {
    GET_OFFBOARDING_LIST: 'client/Offboarding',
    ADD_OFFBOARDING: 'client/Offboarding',
    GET_OFFBOARDING_SCHEMA: 'client/Offboarding/metadata',
    SUBMIT_FILTER_DATA: 'client/Offboarding/filter',
    GET_BY_CLIENT: (clientId) =>
        `client/Offboarding/by-client/${encodeURIComponent(String(clientId ?? "").trim())}`,
    DELETE_BY_ID: (id) => {
        const raw = String(id ?? "").trim();
        return `client/Offboarding/${encodeURIComponent(raw)}`;
    },
}

export const CLIENT_APPRECIATION = {
    GET_CLIENT_APPRECIATION_LIST: 'client/ClientAppreciation',
    ADD_CLIENT_APPRECIATION: 'client/ClientAppreciation',
    GET_CLIENT_APPRECIATION_SCHEMA: 'client/ClientAppreciation/metadata',
    SUBMIT_FILTER_DATA: 'client/ClientAppreciation/filter',
}

export const ONBOARDING = {
    GET_ONBOARDING_LIST: 'client/Onboarding',
    ADD_ONBOARDING: 'client/Onboarding',
    GET_ONBOARDING_SCHEMA: 'client/Onboarding/metadata',
    SUBMIT_FILTER_DATA: 'client/Onboarding/filter',
    GET_CLIENT_LIST: 'Client/filter',
    ONBOARDING_UPSERT: 'client/Onboarding/Upsert',
    /** GET — add-form defaults + restart client search bag. */
    FORM_SCHEMA: 'client/Onboarding/form-schema',
    /** GET — prefill company/billing fields after restart client is chosen. */
    CLIENT_PREFILL: (clientId) =>
        `client/Onboarding/client-prefill/${encodeURIComponent(String(clientId ?? '').trim())}`,
    /** GET — form dropdown options (`{ id, display }`). */
    OPTIONS_AD_SPEND: 'client/Onboarding/options/ad-spend',
    OPTIONS_INDEED_ACCESS: 'client/Onboarding/options/indeed-access',
    OPTIONS_SAFETY: 'client/Onboarding/options/safety',
}

export const REQUIRED = {
    GET_JOB_REQUIRED_LIST : 'master/JobRequire',
    ADD_JOB_REQUIRED : 'pages/add-blog-category',
    EDIT_JOB_REQUIRED : 'pages/update-blog-category',
     GET_JOB_REQUIRED_SCHEMA: 'master/JobRequire/metadata',
    SUBMIT_FILTER_DATA: 'master/JobRequire/filter'
}

export const HOMEPAGE = {
    FETCH_HOME_PAGE: 'pages/get-home-page-section-details',
    UPDATE_HOME_PAGE: 'pages/update-home-page-section-details',
    SUBSCRIPTION_LIST: 'pages/newsletter-subscriptions-list',
    PRIVACY_POLICY: 'pages/privacy-policy',
    UPDATE_PRIVACY_POLICY: 'pages/update-privacy-policy',
    FETCH_IPADDRESS_AND_REGION: 'https://ipapi.co/json/',
    HOME_HEALTH_STATUS: 'Home/health'
}

export const SOCIAL_MEDIA = {
    GET_SOCIAL : 'pages/get-social-links',
    UPDATE_SOCIAL : 'pages/update-social-links',
}

export const SERVICE_LIST = {
    GET_SERVICE_LIST : 'pages/get-services',
    ADD_SERVICE : 'pages/add-service',
    EDIT_SERVICE : 'pages/update-service',
    GET_SERVICE_RECRUITMENT_LIST : 'pages/get-service-recruits',
    ADD_SERVICE_RECRUITMENT : 'pages/add-service-recruit',
    EDIT_SERVICE_RECRUITMENT : 'pages/update-service-recruit',
    GET_PROCESS_LIST : 'pages/get-service-process',
    ADD_SERVICE_PROCESS : 'pages/add-service-process',
    EDIT_SERVICE_PROCESS : 'pages/update-service-process',
    UPDATE_SERVICE_PROCESS_DETAILS: 'pages/update-service-process-details',
    GET_SERVICE_PARTNER_LIST : 'partners/services-list',
    ADD_SERVICE_PARTNER : 'partners/add-service',
    EDIT_SERVICE_PARTNER : 'partners/update-service',
}

export const PRICE = {
    GET_PRICE_LIST : 'pages/get-service-prices',
    ADD_PRICE : 'pages/add-service-price',
    EDIT_PRICE : 'pages/update-service-price',
}

export const CHECKOUT = {
    FETCH_CHECKOUT: 'checkout/fetch-checkout',
    UPDATE_CHECKOUT_DETAILS: 'checkout/update-checkout-page-details'
}

export const TRANSACTION = {
    TRANSACTION_LIST : 'pages/payment-list',
    SYNC_TRANSACTION_LIST : '/payment/sync-pending-payments',
}

export const QUESTION_TYPE = {
    GET_QUESTION_TYPE_LIST : 'master/QuestionType',
    GET_ALL_QUESTIONS : 'master/QuestionTypeDetails',
    GET_QUESTION_TYPE_SCHEMA: 'master/QuestionType/metadata',
    SUBMIT_FILTER_DATA: 'master/QuestionType/filter'
}

export const AUDITING_PARAMETER = {
    GET_AUDITING_PARAMETER_LIST: 'master/AuditingParameter',
    GET_ALL_AUDITING_PARAMETERS: 'master/AuditingParameterDetails',
    GET_AUDITING_PARAMETER_SCHEMA: 'master/AuditingParameter/metadata',
    SUBMIT_FILTER_DATA: 'master/AuditingParameter/filter',
    GET_LEGENDS_PARAMETER_SCHEMA: 'master/Legends/metadata',
    SUBMIT_LEGENDS_FILTER_DATA: 'master/Legends/filter',
    GET_LEGENDS_BY_ID: 'master/Legends',
}

export const LEGENDS = {
    GET_LEGENDS_LIST: 'master/Legends/filter'
}

export const INCENTIVE_MONTHLY = {
    GET_MONTHLY_METADATA: 'incentive/monthly/metadata',
    SUBMIT_MONTHLY_FILTER: 'incentive/monthly/filter',
    GET_MONTHLY_DETAILS: 'incentive/monthly',
    GET_MONTHLY_GENERATE: '/incentive/monthly/generate',
    GET_MONTHLY_TWO_METADATA: 'incentive/monthly/v2/metadata',
    SUBMIT_MONTHLY_TWO_FILTER: 'incentive/monthly/v2/filter',
    GET_MONTHLY_TWO_DETAILS: 'incentive/monthly/v2',
    GET_MONTHLY_THREE_METADATA: 'incentive/monthly/three/metadata',
    SUBMIT_MONTHLY_THREE_FILTER: 'incentive/monthly/three/filter',
    GET_MONTHLY_THREE_DETAILS: 'incentive/monthly/three',
    GET_MONTHLY_THREE_GENERATE: 'incentive/monthly/three/generate',
}

export const TEAM_RECOGNITION_MONTHLY = {
    GET_MONTHLY_METADATA: 'team-recognition/metadata',
    SUBMIT_MONTHLY_FILTER: 'team-recognition/monthly/filter',
    GET_MONTHLY_DETAILS: 'team-recognition/monthly',
    GET_MONTHLY_GENERATE: 'team-recognition/generate',
}

export const AUDITING_TEMPLATE = {
    GET_AUDITING_TEMPLATE_LIST: 'master/AuditingTemplate',
    SUBMIT_AUDITING_TEMPLATE: 'master/AuditingTemplate'
}

export const USER_IP_SETTING = {
    GET_USER_IP_SETTING_SCHEMA: 'Settings/UserIPSetting/metadata',
    SUBMIT_FILTER_DATA: 'Settings/UserIPSetting/filter',
    UPDATE_IS_ALLOWED: (id) =>
        `Settings/UserIPSetting/${encodeURIComponent(String(id ?? "").trim())}`,
}

export const MASTER_SETTING = {
    GET_OVERRIDE_MASTER_SETTINGS: 'Settings/MasterSetting/override',
    UPDATE_OVERRIDE_MASTER_SETTINGS: 'Settings/MasterSetting/override',
    TEST_EMAIL: 'Settings/test-email',
}

export const MAIL_TEMPLATE = {
    GET_MAIL_TEMPLATE_SCHEMA: 'MailTemplate/metadata',
    SUBMIT_FILTER_DATA: 'MailTemplate/filter',
    GET_DEFINITIONS: 'MailTemplate/definitions',
    ADD_MAIL_TEMPLATE: 'MailTemplate',
    GET_MAIL_TEMPLATE_BY_ID: (id) =>
        `MailTemplate/${encodeURIComponent(String(id ?? "").trim())}`,
    UPDATE_MAIL_TEMPLATE: (id) =>
        `MailTemplate/${encodeURIComponent(String(id ?? "").trim())}`,
}

export const CONVERSATION_TEMPLATE = {
    GET_CONVERSATION_TEMPLATE_SCHEMA: 'ConversationTemplate/metadata',
    SUBMIT_FILTER_DATA: 'ConversationTemplate/filter',
    GET_DEFINITIONS: 'ConversationTemplate/definitions',
    ADD_CONVERSATION_TEMPLATE: 'ConversationTemplate',
    GET_CONVERSATION_TEMPLATE_BY_ID: (id) =>
        `ConversationTemplate/${encodeURIComponent(String(id ?? "").trim())}`,
    UPDATE_CONVERSATION_TEMPLATE: (id) =>
        `ConversationTemplate/${encodeURIComponent(String(id ?? "").trim())}`,
}

export const AI_SMS_TEMPLATE = {
    GET_AI_SMS_TEMPLATE_SCHEMA: 'AISmsTemplate/metadata',
    SUBMIT_FILTER_DATA: 'AISmsTemplate/filter',
    GET_DEFINITIONS: 'AISmsTemplate/definitions',
    ADD_AI_SMS_TEMPLATE: 'AISmsTemplate',
    GET_AI_SMS_TEMPLATE_BY_ID: (id) =>
        `AISmsTemplate/${encodeURIComponent(String(id ?? "").trim())}`,
    UPDATE_AI_SMS_TEMPLATE: (id) =>
        `AISmsTemplate/${encodeURIComponent(String(id ?? "").trim())}`,
}

export const AI_ADDON_CALL_TEMPLATE = {
    GET_AI_ADDON_CALL_TEMPLATE_SCHEMA: 'AIAddonCallTemplate/metadata',
    SUBMIT_FILTER_DATA: 'AIAddonCallTemplate/filter',
    GET_DEFINITIONS: 'AIAddonCallTemplate/definitions',
    ADD_AI_ADDON_CALL_TEMPLATE: 'AIAddonCallTemplate',
    GET_AI_ADDON_CALL_TEMPLATE_BY_ID: (id) =>
        `AIAddonCallTemplate/${encodeURIComponent(String(id ?? "").trim())}`,
    UPDATE_AI_ADDON_CALL_TEMPLATE: (id) =>
        `AIAddonCallTemplate/${encodeURIComponent(String(id ?? "").trim())}`,
}

export const AI_SCHEDULE_MATRIX = {
    METADATA: 'ai-schedule-matrix/metadata',
    LIST: 'ai-schedule-matrix',
    BY_ID: (id) =>
        `ai-schedule-matrix/${encodeURIComponent(String(id ?? "").trim())}`,
}

export const AI_SCHEDULE_MATRIX_GROUP = {
    METADATA: 'ai-schedule-matrix-group/metadata',
    LIST: 'ai-schedule-matrix-group',
    BY_ID: (id) =>
        `ai-schedule-matrix-group/${encodeURIComponent(String(id ?? "").trim())}`,
}

export const NOTIFICATION_SETTINGS = {
    METADATA: 'Settings/NotificationSettings/metadata',
    FILTER: 'Settings/NotificationSettings/filter',
    CREATE: 'Settings/NotificationSettings',
    BY_ID: (id) =>
        `Settings/NotificationSettings/${encodeURIComponent(String(id ?? "").trim())}`,
}

/** Bad Fit Resolution Reason master — metadata, filter, CRUD */
export const BAD_FIT_RESOLUTION_REASON = {
    LIST: 'master/BadFitResolutionReasonMaster',
    METADATA: 'master/BadFitResolutionReasonMaster/metadata',
    FILTER: 'master/BadFitResolutionReasonMaster/filter',
    BY_ID: (id) =>
        `master/BadFitResolutionReasonMaster/${encodeURIComponent(String(id ?? "").trim())}`,
}

/** Masked ID resolution — table ID column unmask. */
export const META = {
    UNMASK: (maskedId) =>
        `Meta/unmask/${encodeURIComponent(String(maskedId ?? "").trim())}`,
}

